// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wc_a bhm_b","TwoDimsListFeature__item":"wc_b bhm_we","TwoDimsListFeature__item__text":"wc_c bhm_vt"};